export enum OrganizationStatus {
    Active = 'active',
    Blocked = 'blocked',
}